const subscriptions = {
  onUpdateMaintenanceMode: `subscription UpdateMaintenanceMode {
        onUpdateMaintenanceMode {
            state
            message
        }
    }`,
}
export default subscriptions
